export const LECTURE_TYPES = {
  regular: 'Regular',
  optional: 'Optional',
};
